import { defineAction } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'
import collectionIncentiveReportAction from './collectionIncentiveReport.action.json' with { type: 'json' }

const collectionIncentiveReportDefinition = defineAction({
  ...collectionIncentiveReportAction,

  input: z.object({
    format: reportFormatSchema,
    startDate: dateOrIsoString().nullish(),
    endDate: dateOrIsoString().nullish(),
  }),
  output: z.any(),
})

export default collectionIncentiveReportDefinition
